module.exports = __webpack_public_path__ + "img/responsible-gambling-bg-mob.d41db0f7.png";